import React, { useMemo } from 'react';
import {connect} from 'react-redux';
import { Popover, PopoverBody } from 'reactstrap';
import { moveMessages as moveMessagesService } from '../../services/message';
import { getCredentials } from '../../selectors/application';
import { getSelectedFolder } from '../../selectors/folders';

import InboxIcon from '../../assets/icons/icon-inbox.svg?react';
import DeleteIcon from '../../assets/icons/delete.svg?react';
import DocTextIcon from '../../assets/icons/doc-text.svg?react';
import SendIcon from '../../assets/icons/send-arrow.svg?react';
import FolderIcon from '../../assets/icons/folder.svg?react';
import './move-to-popover.scss';

const MoveToPopover = ({ 
  showFolderList, 
  setShowFolderList,
  folders,
  folderTree,
  selectedFolder,
  selectedMessages,
  selectedMessage,
  moveMessages,
}) => {
  const mainFolders = useMemo(
    () => (folderTree || [])
      .map(folder => folders?.[folder.folderId])
      .filter(Boolean),
    [folderTree, folders]
  );

  const getIcon = (graphic) => {
      switch (graphic) {
        case 'move_to_inbox':
          return <InboxIcon className="item-icon" />;
        case "delete_outline":
          return <DeleteIcon className="item-icon" width={12} height={14} />;
        case "border_color":
          return <DocTextIcon className="item-icon" />;
        case "send":
          return <SendIcon className="item-icon" width={14} height={11} />;
        default:
          return <FolderIcon className="item-icon" fill="var(--grey-800)" />;
      }
  }

  const onSelectFolder = toFolder => {
    if (!selectedFolder || !selectedFolder.folderId || !toFolder || !toFolder.folderId) {
      setShowFolderList(false);
      return;
    }
    if (toFolder.folderId === selectedFolder.folderId) {
      setShowFolderList(false);
      return;
    }
    const selectedFromCurrentFolder = (selectedMessages || []).filter(
      selected => selected.folderId === selectedFolder.folderId && (
        (selected.uid && selected.uid) || (!selected.uid && selected.messageId)
      )
    );
    const messagesToMove = selectedFromCurrentFolder.length > 0
      ? selectedFromCurrentFolder
      : selectedMessage
        ? [{ ...selectedMessage, folderId: selectedFolder.folderId }]
        : [];
    if (messagesToMove.length === 0) {
      setShowFolderList(false);
      return;
    }
    moveMessages(selectedFolder, toFolder, messagesToMove);
    setShowFolderList(false);
  };

  return (
    <Popover
      isOpen={showFolderList}
      trigger="legacy"
      target="move-to-folder-popover"
      toggle={() => {
        setShowFolderList(false);
      }}
      placement="bottom"
      className="move-to-popover"
    >
      <PopoverBody>
        <div className="move-to-popover__list">
          {mainFolders.map(folder => (
            <div
              key={folder.folderId}
              className="move-to-popover__item"
              onClick={() => onSelectFolder(folder)}
            >
              {getIcon(folder.type?.icon)}
              <span className="move-to-popover__label">{folder.name}</span>
            </div>
          ))}
        </div>
      </PopoverBody>
    </Popover>
  )
    
};

const mapStateToProps = state => ({
  folderTree: state.folders.items,
  folders: state.folders.explodedItems,
  selectedFolder: getSelectedFolder(state) || {},
  selectedMessages: state.messages.selected,
  selectedMessage: state.application.selectedMessage,
  credentials: getCredentials(state),
  user: state.application.user,
  lexon: state.lexon,
});

const mapDispatchToProps = dispatch => ({
  moveMessages: (credentials, fromFolder, toFolder, messages, user, lexon) => {
    moveMessagesService(
      dispatch,
      credentials,
      fromFolder,
      toFolder,
      messages,
      user,
      lexon
    );
  }
});

const mergeProps = (stateProps, dispatchProps, ownProps) => (Object.assign({}, stateProps, dispatchProps, ownProps, {
  moveMessages: (fromFolder, toFolder, messages) =>
    dispatchProps.moveMessages(
      stateProps.credentials,
      fromFolder,
      toFolder,
      messages,
      stateProps.user,
      stateProps.lexon,
    )
}));

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(MoveToPopover);